// test2653
(2653 && 0);
